const ja = {
  // Navbar
  nav_home: "ホーム",
  nav_about: "てんてんおじさんとは",
  nav_services: "鑑定メニュー・料金",
  nav_flow: "ご利用の流れ",
  nav_testimonials: "お客様の声",
  nav_faq: "よくある質問",
  nav_contact: "お問い合わせ",
  nav_cta: "鑑定を申し込む",
  nav_subtitle: "沖縄・姓名判断",
  nav_title: "てんてんおじさん鑑定所",

  // Hero
  hero_headline1: "沖縄の離島で、",
  hero_headline2: "静かに名前と",
  hero_headline3: "向き合い続ける",
  hero_headline4: "てんてんおじさん。",
  hero_body: "半年以上待つ方も多い人気の鑑定を、\nあなたに代わって私が毎月1回、現地へ伺い\nお名前を一つずつお預けしています。",
  hero_pill1: "改名は不要",
  hero_pill2: "オンラインで完結",
  hero_pill3: "最短1ヶ月以内にお届け",
  hero_pill4: "毎月先着100名",
  hero_btn_apply: "鑑定を申し込む",
  hero_btn_services: "サービス詳細",
  hero_scroll: "SCROLL",

  // About
  about_heading: "てんてんおじさんとは",
  about_intro: "沖縄の静かな海に包まれた島、<strong>伊計島</strong>。\nその穏やかな空気の中で、一人ひとりの名前に、そっと光を添えている方がいます。\n人々は、親しみを込めて<strong>「てんてんおじさん」</strong>と呼びます。",
  about_block1_label: "銀行員から、名前と向き合う道へ",
  about_block1_text: "てんてんおじさんは、もともと銀行員でした。\n努力を積み重ね、<strong>最年少で支店長</strong>へ。たくさんの人と関わる中で、ある問いが心に生まれたといいます。",
  about_block1_quote: "「同じように頑張っていても、どうして人によって、風向きが変わるのだろう？」",
  about_block1_sub: "その小さな疑問が、やがて大きな探求の始まりになりました。",
  about_block2_label: "古い姓名の知恵と、静かなひらめき",
  about_block2_text: "空いた時間すべてを使い、古い姓名判断の文献を読み解き、旧字の画数や音の流れをひとり、深く、丁寧に研究されました。",
  about_block2_text2: "やがて気づかれたのは、<strong>「てんてんが、名前の流れを静かに整えることがある」</strong>ということ。",
  about_block2_sub: "それは劇的な魔法でも、派手な成功法則でもなく、\nもともと人が持っている光を、そっと見えやすくする働きでした。",
  about_block3_label: "口コミだけで広がり、半年待ちに",
  about_block3_text: "その優しい鑑定は、口コミだけで広がり、今では<strong>全国から依頼が集まります</strong>。\n有名人でも、そうでない方でも、先生はどの方にも同じように向き合います。\nひとりの名前に手を添え、その人の人生に寄り添うように。\nそれが、てんてんおじさんのスタイルです。",

  // Gallery
  gallery_heading: "ギャラリー",
  gallery_sub: "沖縄・伊計島の風景",

  // Services
  services_heading: "鑑定メニュー・料金",
  services_note1: "※ 料金には、先生の鑑定料と現地代行費がすべて含まれています。",
  services_note2: "※ 追加費用はありません。どうぞ安心してお任せください。",
  services_tab1: "個人のお名前",
  services_tab2: "屋号・ビジネスネーム",
  services_tab3: "ペットのお名前",
  services_tab1_en: "Personal Name",
  services_tab2_en: "Business Name",
  services_tab3_en: "Pet Name",
  services_tab1_desc: "成長や環境、心の動きをそっと見つめながら、その方に合った\u201cてんてん\u201dを添えていきます。",
  services_tab2_desc: "新しい挑戦にそっと追い風を。事業の流れを、やわらかく整えます。",
  services_tab3_desc: "家族としてずっとそばにいる存在。安心とやさしさが灯る名前をお届けします。",
  services_row1_target1: "16歳以上",
  services_row1_target2: "4〜15歳",
  services_row1_target3: "0〜3歳",
  services_row2_target1: "店名・会社名・ビジネスネーム",
  services_row3_target1: "ペットのお名前",
  services_col_target: "対象",
  services_col_price: "料金（税込）",
  services_cta: "このメニューで申し込む",
  services_includes_title: "鑑定に含まれるもの（すべて料金内）",
  services_inc1: "姓名鑑定",
  services_inc2: "最適な\u201cてんてん\u201dのご提案",
  services_inc3: "希望者へ名刺サイズカード郵送（無料）",
  services_inc4: "開運のためのアドバイス",
  services_inc5: "お名前カードの写真データ",
  services_includes_note: "名前に小さな光を足し、今ある魅力をそっと引き出すための鑑定です。",
  services_payment_title: "お支払いについて",
  services_payment_method: "銀行振込（前払い）",
  services_payment_desc: "お申し込み後に振込先をご案内します。\nお手続きが完了した瞬間から、運の流れは静かに整い始めます。",
  services_first_title: "はじめての方へ",
  services_first_desc: "迷いがあるのは自然なことです。\nそれは「そろそろ変わりはじめたい」という\n心の合図。",
  services_first_cta: "まずはご相談から",

  // Flow
  flow_heading: "ご利用の流れ",
  flow_step1_title: "お申し込みフォームから送信",
  flow_step1_c1: "専用フォームに必要事項をご入力ください。",
  flow_step1_c2: "送信完了後、通常2〜3営業日以内に返信メールが届きます。",
  flow_step1_c3: "メール内に今後の流れとお振込みのご案内が記載されています。",
  flow_step2_title: "鑑定料のお振込み",
  flow_step2_c1: "返信メールに記載の口座へ、鑑定料をお振込みください。",
  flow_step2_c2: "お振込みを確認後、順番に鑑定の準備を進めさせていただきます。",
  flow_step3_title: "お振込み完了のご連絡",
  flow_step3_c1: "お振込み後、メールに記載のアドレス宛に振込明細（または振込用紙）の写真をお送りください。",
  flow_step3_c2: "確認が取れ次第、「受付完了」のメッセージをお送りします。",
  flow_step3_note: "こちらのご連絡がない場合、鑑定を開始できない場合がありますので、必ずお送りください。",
  flow_step4_title: "鑑定結果のご報告",
  flow_step4_c1: "鑑定後、約1週間以内に「てんてん入りのお名前カード」の写真をメールでお届けします。",
  flow_step4_c2: "その後、鑑定内容の詳細と開運のアドバイスをまとめた鑑定結果をメールにてお送りします。",
  flow_step5_title: "名刺カードの郵送（希望者のみ）",
  flow_step5_c1: "ご希望の方には、先生直筆の「てんてん入りお名前カード（名刺サイズ）」を後日郵送でお送りします。",
  flow_step5_c2: "お申し込みフォームの住所欄に、正確な郵送先をご記入ください。",
  flow_step5_note: "カードが不要な方は、市町村までの記入で構いません。",
  flow_banner_title: "すべてオンラインで完結。全国どこからでも。",
  flow_banner_desc: "沖縄・伊計島まで足を運ぶ必要はありません。\n日々の生活を変えることなく、そのままの自分で始められます。",
  flow_banner_cta: "お申し込みはこちら",

  // Testimonials
  testimonials_heading: "お客様の声",
  testimonials_viewing: "表示中",

  // FAQ
  faq_heading: "よくあるご質問",
  faq_cta_title: "ほかに気になることは？",
  faq_cta_desc: "ちいさなことでも大丈夫です。\n「こんなこと聞いていいのかな？」と思うことほど、ぜひお気軽に。",
  faq_cta_btn: "お気軽にご相談ください",

  // CTA Banner
  cta_heading1: "今すぐ",
  cta_heading2: "無料相談",
  cta_btn: "ご予約はこちら",

  // Contact
  contact_heading: "お問い合わせ",
  contact_desc: "鑑定のご依頼・ご相談はこちらのフォームよりお気軽にお問い合わせください。通常2〜3営業日以内にご返信いたします。",
  contact_address_label: "所在地",
  contact_address_value: "栃木県（オンライン対応・全国可）",
  contact_email_label: "メール",
  contact_hours_label: "受付時間",
  contact_hours_value: "平日 9:00〜18:00（土日祝休）",
  contact_note_title: "ご返信について",
  contact_note_desc: "迷惑メールフォルダに振り分けられる場合がございます。\n2〜3営業日経過しても返信がない場合は、メールにて直接ご連絡ください。",
  contact_field_name: "お名前",
  contact_field_furigana: "フリガナ",
  contact_field_email: "メールアドレス",
  contact_field_phone: "電話番号",
  contact_field_service: "ご希望のサービス",
  contact_field_message: "お問い合わせ内容",
  contact_placeholder_name: "山田 太郎",
  contact_placeholder_furigana: "ヤマダ タロウ",
  contact_placeholder_email: "example@email.com",
  contact_placeholder_phone: "090-0000-0000",
  contact_placeholder_message: "鑑定したいお名前や、ご質問・ご要望などをご記入ください。",
  contact_select_placeholder: "選択してください",
  contact_service1: "個人のお名前",
  contact_service2: "屋号・ビジネスネーム",
  contact_service3: "ペットのお名前",
  contact_service4: "その他・ご相談",
  contact_submit: "送信する",
  contact_submitting: "送信中...",
  contact_privacy: "送信いただいた個人情報は鑑定業務のみに使用いたします。",
  contact_error: "送信に失敗しました。時間をおいて再度お試しいただくか、メールにて直接ご連絡ください。",
  contact_err_name: "お名前を入力してください",
  contact_err_email_required: "メールアドレスを入力してください",
  contact_err_email_invalid: "正しいメールアドレスを入力してください",
  contact_err_service: "ご希望のサービスを選択してください",
  contact_err_message_required: "お問い合わせ内容を入力してください",
  contact_err_message_limit: "500文字以内で入力してください",
  contact_thanks_title: "送信が完了しました",
  contact_thanks_desc: "お問い合わせいただき、ありがとうございます。\n内容を確認のうえ、<strong>2〜3営業日以内</strong>にご返信いたします。\nしばらくお待ちください。",
  contact_thanks_check1: "確認メールをご確認ください",
  contact_thanks_check2: "迷惑メールフォルダもご確認を",
  contact_thanks_check3: "返信まで2〜3営業日お待ちください",
  contact_thanks_another: "別のお問い合わせをする",

  // Footer
  footer_subtitle: "沖縄・姓名判断",
  footer_title: "てんてんおじさん鑑定所",
  footer_desc: "沖縄から全国へ。50年以上の実績を持つ姓名判断鑑定士が、あなたとご家族の名前に宿る運命を丁寧に鑑定いたします。",
  footer_contact_title: "CONTACT INFO",
  footer_address_label: "ADDRESS",
  footer_address_value: "栃木県\n（オンライン対応・全国可）",
  footer_email_label: "EMAIL",
  footer_hours_label: "HOURS",
  footer_hours_value: "平日 9:00〜18:00\n（土日祝休）",
  footer_nav_title: "NAVIGATION",
  footer_copyright: "© 2025 てんてんおじさん鑑定所. All rights reserved.",
  footer_privacy: "プライバシーポリシー",
  footer_law: "特定商取引法に基づく表記",
  footer_sitemap: "サイトマップ",
};

export default ja;
